import { StarRating } from '@/src/components/star-rating/StarRating';

type IProps = {
  reviews: number;
};

export const DestinationDetailsReviews = ({ reviews }: IProps) => {
  return (
    <div className={'flex gap-1.5'}>
      <p className={'text-sm font-semibold'}>{reviews}</p>
      <div className={'translate-y-1'}>
        <StarRating rating={reviews} size={10} />
      </div>
    </div>
  );
};
